<template>
<div class="chapter">
<div class="inner_page">
<h1><a id="page1"></a>Praise for<br/>The Naked Gospel</h1>
<p class="noindent first">How do you know a sailboat is maxed out in the wind? The author’s wife, a sailboat captain, can tell you. It hydroplanes. How do you know it’s hydroplaning? You listen for the hum. This book shows you how to open the sails of your life to the winds of truth and max out in God’s Spirit. Read this book and hear the hum.</p>
<blockquote>
<p class="hang">     —L<span class="small">EONARD</span> S<span class="small">WEET</span>,<br/>bestselling author of <i>So Beautiful:<br/>Divine Design for Life and the Church</i></p>
</blockquote>
<p class="noindent">Our culture screams at us, “Productivity!”—and often, this mantra gets absorbed and spread by the church. <i>Grace</i> is a word we use often but rarely understand the depth and true meaning of. In <i>The Naked Gospel,</i> Andrew Farley strips down religion and shows us the faith and freedom God intends for us to have in a fully abundant, radiant life.</p>
<blockquote>
<p class="hang">     —A<span class="small">NNE</span> J<span class="small">ACKSON</span>,<br/>speaker and author of <i>Mad Church</i></p>
</blockquote>
<p class="noindent">What a great “textbook” on how to strip away all the religious fakery and take the challenge to just be a normal person while being a healthy Christian.</p>
<blockquote>
<p class="hang">     —S<span class="small">TEVE</span> A<span class="small">RTERBURN</span>,<br/>founder and chairman<br/>of New Life Ministries</p>
</blockquote>
<p class="noindent"><a id="page2"></a>Reading Andrew Farley’s book <i>The Naked Gospel</i> harkened me back to my own faith-altering encounter with Jesus when I first embraced the outrageous idea of the exchanged life. That message dynamically changed me, which is why I’m excited about Andrew’s book—a biblically centered freedom manual for today’s stuck Christian. If you’re tired of wearing the “I’m a super Christian” mask, if you’re weary and discouraged on the inside, read this book and experience the freedom Jesus brings.</p>
<blockquote>
<p class="hang">      —M<span class="small">ARY</span> D<span class="small">EMUTH</span>,<br/>author of <i>Daisy Chain</i></p>
</blockquote>
<p class="noindent"><i>The Naked Gospel</i> is an intelligently written book that is thoroughly intriguing. Your church or small group could benefit greatly by its wisdom and concepts. This is a must-read!</p>
<blockquote>
<p class="hang">      —D<span class="small">AVE</span> S<span class="small">TONE</span>,<br/>senior minister,<br/>Southeast Christian Church</p>
</blockquote>
<p class="noindent"><a id="page3"></a>The message that Andrew Farley brings in <i>The Naked Gospel</i> is so necessary for the church today. It is absolutely essential for a fulfilling and genuinely Christ-centered life.</p>
<blockquote>
<p class="hang">     —J<span class="small">OHN</span> B<span class="small">EST</span>, ThD,<br/>former professor of New Testament<br/>Literature and Exegesis,<br/>Dallas Theological Seminary</p>
</blockquote>
<p class="noindent">For over three years, I have co-hosted radio and television programs with Dr. Andrew Farley. God has gifted this insightful teacher and author with the ability to communicate the meaning of the Scriptures with remarkable simplicity. The clarity of his words should refresh the spirit of every saint and beckon to the lost. The heart of his message is captured here, and it comes at the perfect time, when the United States, and indeed the whole world, is hungering for answers. <i>The Naked Gospel</i> is unabashed truth.</p>
<blockquote>
<p class="hang">     —C<span class="small">HIP</span> P<span class="small">OLK</span>,<br/>cofounder and playwright,<br/>Ragtown Gospel Theater</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003praise.vue?4f5c1cbe